
















import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { IssueViewerConfigDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "IssueViewerConfigForm",
		components: { ButtonList }
	})
export default class IssueViewerConfigForm extends ParticaBaseForm<IssueViewerConfigDTO> {

	private contentconfig =
		{
			props: {
				name: "Configuration",
				placeholder: "Enter your JSON configuration",
				label: "Issue Viewer Configuration",
			} as FormFieldProps,
			rules: { required: true, max: 1500, min: 0, } as FormFieldRules
		} as IFormField;

}
